export default () => {
  const customPlayback = (element) => {
    const video = element.previousElementSibling;

    if (!video) {
      return;
    }

    const playPauseButton = element;
    const playPauseButtonText = element.querySelector('.visually-hidden');

    if (video.paused) {
      video.play();
      // Cleared so the global scroll-pause manager may auto-resume it on re-entry.
      delete video.dataset.manuallyPaused;
      playPauseButtonText.textContent = 'Pause';
      playPauseButton.setAttribute('aria-label', 'Pause video');
    } else {
      video.pause();
      // Flagged so the global scroll-pause manager never auto-resumes it.
      video.dataset.manuallyPaused = 'true';
      delete video.dataset.scrollAutoPaused;
      playPauseButtonText.textContent = 'Play';
      playPauseButton.setAttribute('aria-label', 'Play video');
    }
  };

  document.addEventListener('click', (e) => {
    const el = e.target;

    if (el.classList.contains('action-video')) {
      customPlayback(el);
    }
  });
};
